<template lang="pug">
.mb-5
  envelope-step-bar(:step='1')
  .alert.alert-warning.alert-dismissible.fade.show(
    role='alert'
    v-if='dontHaveCredits'
  )
    div(style='display: flex; align-items: center')
      icon.icon-left(name='circle-exclamation')
      span(style='font-weight: bold; margin-right: 10px')
        | {{ $t('modal.envelope.selectDocuments.creditsLimit', { planIntervalName }) }}
      button.close(
        aria-label='Close'
        data-bs-dismiss='alert'
        type='button'
      )
        span &times
    div
      | {{ $t('modal.envelope.selectDocuments.waitRenewal') }}
      |
      button.btn-link-menu(type='button')
        router-link.plan-details-link(
          :to='{ name: "account.billing.plan", query: { tab: "plans" } }'
        ) {{ $t('modal.envelope.selectDocuments.upgradePlan') }}
      |
      | {{ $t('modal.envelope.selectDocuments.continueSending') }}

  .card.card--file-loader.mb-5
    .card-body(
      :class='["dropzone-area", dragging ? "dragenterClass" : ""]'
      @dragend='dragging = false'
      @dragenter='dragging = true'
      @dragleave='dragging = false'
      @dragover.prevent='dragover'
      @drop.prevent='drop'
    )
      input(
        :accept='allowedFileType.join()'
        multiple='multiple'
        ref='inputFile'
        style='display: none'
        type='file'
      )
      label.notclickable.block.cursor-pointer(for='assetsFieldHandle')
        h3.card-title {{ $t('upload.dragHere') }}
        p.font-size-subtitle.mb-2 {{ $t('upload.or') }}
        button.btn.btn-thin(@click='openfileUploadModal') {{ $t('upload.searchIn') }}
        p.font-size-small.mb-0.mt-2 {{  $t('pages.dashboard.fileExtensions',{ extensions: `\"${allowedFileExtensions.join('\", \"')}\"`, maxFileSizeMb: maxFileSizeMB })  }}
        p.font-size-small.mb-0 {{ $t('modal.envelope.selectDocuments.maxFilesPerEnvelope', { maxFilesPerEnvelope }) }}
        p.font-size-small.mb-0 {{ $t('modal.envelope.selectDocuments.maxSizePerEnvelope', { maxSizePerEnvMB: maxEnvelopeSizeMB }) }}
  .files-list.mb-5(v-if='files.length > 0')
    h6.mb-4 {{ $t('modal.envelope.selectDocuments.selectedFiles') }}
    .w-100.d-flex.flex-wrap
      .clearfix.mb-4.col-md-3.col-sm-4(
        :key='file.id || `file${index}`'
        v-for='(file, index) in files'
      )
        template(v-if='file.file')
          .file-item(:title='file.file.name')
            .actions(v-if='!file.loading')
              button(
                :title='$t("modal.envelope.selectDocuments.remove")'
                @click='removeFile(file)'
              )
                icon(name='trash')
              button(
                :title='$t("modal.envelope.selectDocuments.retry")'
                @click='retryFile(file)'
                v-if='file.error && file.canRetry'
              ) 
                icon(name='rotate-right')
            .preview.d-flex(:style='`background-color: #F0F0F0`')
              template(v-if='file.loading')
                span.icon(style='font-size: 0.8em') {{ $t('modal.envelope.selectDocuments.loading') }}
              template(v-else)
                icon(name='file-lines')
            template(v-if='!file.error') 
              .file-name {{ file.file.name }}
            template(v-else) 
              .file-error.danger {{ file.error }}
        template(v-else)
          .file-item(:title='file.name')
            .actions
              button(
                :title='$t("modal.envelope.selectDocuments.remove")'
                @click='removeFile(file)'
              )
                icon(name='trash')
            .preview(:style='`background-image: url(${file.links.preview})`')
            .file-name {{ file.name }}
  envelope-bottom-bar(
    :enableGeneratePDFA='hasPDFAEnabled'
    :hidden='hasFileError'
    :typePDFA='typePDFA'
    @generatePDFA='typePDFA = $event'
    @nextStep='next'
    @saveAndClose='saveAndClose'
    v-if='hasFiles'
  )
  file-local-loader-modal(
    :allowed-file-extensions='allowedFileExtensions'
    :allowed-file-type='allowedFileType'
    :max-file-size-mb='maxFileSizeMB'
    @selected-files='onSelectFiles'
    ref='fileUpload'
  )
  warning-save-and-close-envelope-modal(
    @discardChanges='discardChanges'
    @saveAndClose='saveAndClose'
    ref='saveAndCloseModal'
  )
    p.mb-0 {{ $t('modal.envelope.selectDocuments.confirmDiscard') }}
</template>
<script>
import EnvelopeAcceptedFileTypes from '@/enums/EnvelopeAcceptedFileTypes';
import FileLocalLoaderModal from '@/ui/organisms/modals/FileLocalLoaderModal.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import Icon from '@/ui/atoms/Icon.vue';
import TopPageBar from '@/ui/organisms/TopPageBar.vue';
// eslint-disable-next-line max-len
import WarningSaveAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseEnvelope.vue';
import ToastAlert from '@/modules/account/common/alert';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import EnvelopeStepBar from '@/ui/organisms/EnvelopeStepBar.vue';
import alert from '@/modules/account/common/alert';

export default {
  name: 'EnvelopeSelectFiles',
  components: {
    FileLocalLoaderModal,
    Icon,
    TopPageBar,
    WarningSaveAndCloseEnvelopeModal,
    ToastAlert,
    EnvelopeBottomBar,
    EnvelopeStepBar,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'business.envelope.recipients' ||
      !this.hasChanges ||
      to.name === 'business.documents.draft'
    ) {
      next();
      return;
    }
    this.$refs.saveAndCloseModal.$refs.modal.open();
    this.nextRoute = next;
  },
  data() {
    return {
      files: [],
      typePDFA: false,
      dragging: false,

      allowedFileType: [].concat(
        EnvelopeAcceptedFileTypes.mimeTypes,
        EnvelopeAcceptedFileTypes.extensions
      ),
      allowedFileExtensions: EnvelopeAcceptedFileTypes.extensions,
      nextRoute: null,
      internalEnvelopeId: null,
    };
  },
  created() {
    this.updatePageTitleAndHead();
  },
  mounted() {
    this.$store.dispatch('envelopeConfig/fetchConfigs');
  },
  async beforeMount() {
    if (this.isNew) {
      this.$store.state.envelope.documents.forEach((file) => {
        this.files.push(file);
      });
      this.$store.dispatch('envelope/addDocuments', []);
      return;
    }

    await this.loadFiles();
  },
  computed: {
    isNew() {
      return this.envelopeId === undefined;
    },
    envelopeId() {
      return this.$route.params.id;
    },
    hasFiles() {
      return this.files.length > 0;
    },
    hasFileError() {
      return this.hasFilesErrors();
    },
    hasChanges() {
      return this.hasFiles;
    },
    dontHaveCredits() {
      return !this.$store.getters['subscription/hasCredits'];
    },
    hasPDFAEnabled() {
      const organizationSelected = this.$store.state.organizations.selected;
      const typePDFAEnable =
        organizationSelected?.metadata['envelope.type.pdfa'] ?? false;

      return typePDFAEnable;
    },
    planIntervalName() {
      switch (this.$store.state.subscription.plan?.plan?.interval) {
        case 1:
          return this.$t('pages.planDetails.planInterval.1');
        case 6:
          return this.$t('pages.planDetails.planInterval.6');
        case 12:
          return this.$t('pages.planDetails.planInterval.12');
        default:
          return this.$t('pages.selectDocuments.cycle');
      }
    },
    maxFileSizeMB() {
      return (
        this.$store.getters['envelopeConfig/singleDocumentSizeLimitMB'] || 25
      );
    },
    maxFilesPerEnvelope() {
      return (
        this.$store.getters['envelopeConfig/documentsPerEnvelopeLimit'] || 25
      );
    },
    maxEnvelopeSizeMB() {
      return (
        this.$store.getters['envelopeConfig/documentsPerEnvelopeSizeLimitMB'] ||
        100
      );
    },
  },
  methods: {
    updatePageTitleAndHead() {
      const pageTitle = this.isNew
        ? this.$t('newEnvelope')
        : this.$t('editEnvelope');
      this.$store.dispatch('page/setTitle', pageTitle);
      this.$store.dispatch('page/setHead', {
        title: pageTitle,
      });
    },
    async loadFiles() {
      this.$loading(true);
      const res = await EnvelopesService.getExtendedEnvelope(
        this.$route.params.id
      );
      res.data.documents.forEach((f) => {
        const file = f;
        file.fromApi = true;
        this.files.push(file);
      });

      if (res.data.metadata['type.pdfa']) {
        this.typePDFA = res.data.metadata['type.pdfa'];
      }

      this.$loading(false);
    },
    openfileUploadModal() {
      this.$refs.fileUpload.$refs.modal.open();
    },
    async next() {
      let envelopeId = this.envelopeId;
      if (this.isNew) {
        envelopeId = await this.createEnvelope();
        if (!envelopeId) {
          console.warn('Error creating envelope');
          return;
        }
      }

      if (this.hasPDFAEnabled && !this.isNew) {
        console.info(
          'Metadata PDF-A enabled for this organization, updating metadata...'
        );
        const updated = await this.updateMetadata(envelopeId);
        if (updated === false) {
          return;
        }
      }

      if (envelopeId && !this.hasFilesErrors()) {
        this.$router.replace({
          name: 'business.envelope.recipients',
          params: { id: envelopeId, isNew: this.isNew },
        });
      }
    },
    async createEnvelope() {
      this.$loading(true);
      try {
        const [firstFile] = this.files;
        let envelopeTitle = '';
        if (firstFile.file) {
          envelopeTitle = firstFile.file.name;
        }
        if (firstFile.name) {
          envelopeTitle = firstFile.name;
        }
        if (envelopeTitle.length > 60) {
          envelopeTitle =
            envelopeTitle.substr(0, 50) +
            '...' +
            envelopeTitle.split('.').pop();
        }

        const metadata = {};
        if (this.typePDFA) {
          metadata['type.pdfa'] = this.typePDFA;
        }

        if (!this.internalEnvelopeId) {
          const response = await EnvelopesService.create({
            title: envelopeTitle,
            metadata: metadata,
          });
          if (response.status !== 201) {
            return false;
          }
          // save first time tried when upload docs on envelope
          this.internalEnvelopeId = response.data.id;
        }
        const pendingFiles = this.files.filter(
          (file) => !file.fromApi && !file.error
        );
        if (pendingFiles.length > 0) {
          const results = await this.addFiles(
            this.internalEnvelopeId,
            pendingFiles
          );
          this.processFilesResults(results);
        }
        const hasDocumentsOnServer = this.files.some((file) => file.fromApi);
        if (this.hasFilesErrors() || !hasDocumentsOnServer) {
          console.error({
            message:
              'Error adding files. No files were accepted by the server.',
            timestamp: new Date().toISOString(),
          });
          return false;
        }
        return this.internalEnvelopeId;
      } catch (error) {
        let message = this.$t('modal.envelope.saveError');
        ToastAlert.fireAlert(message, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return false;
      } finally {
        this.$loading(false);
      }
    },
    async updateMetadata(envelopeId) {
      try {
        const response = await EnvelopesService.update(envelopeId, {
          metadata: {
            'type.pdfa': this.typePDFA,
          },
        });

        if (response.status != 200 && response.status != 422) {
          return false;
        }
      } catch (error) {
        ToastAlert.fireAlert(
          `${this.$t('modal.envelope.updateError')} ${
            error.response.data.message
          }`,
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          }
        );

        this.$loading(false);
        return false;
      }
    },
    async addFiles(envelopeId, files) {
      EnvelopesService.supressDefault = true;

      if (files.length === 0) {
        return;
      }

      const promises = files.map((file) => {
        if (file.id) {
          return EnvelopesService.addDocument(envelopeId, file.id)
            .then((res) => ({
              status: 'success',
              file,
              data: res.data,
            }))
            .catch((error) => ({
              status: 'error',
              file,
              error,
            }));
        }

        if (file.file) {
          return EnvelopesService.addDocumentFile(envelopeId, file.file)
            .then((res) => ({
              status: 'success',
              file,
              data: res.data,
            }))
            .catch((error) => ({
              status: 'error',
              file,
              error,
            }));
        }

        console.warn('File skipped: ', file);
        //fallback
        return Promise.resolve({
          status: 'skipped',
          file,
          reason: 'not supported file',
        });
      });

      return await Promise.all(promises);
    },
    processFileErrorMessage(result) {
      const error = result.error;
      const apiMessage = result?.error?.response?.data?.message;
      let fileErrorMessage = '';

      console.error({
        api: apiMessage,
        file: result.file.file.name,
        error: result?.error,
        timestamp: new Date().toISOString(),
      });

      if (error.response?.status === 403) {
        console.error({
          message: 'The uploaded file was not received by the server.',
          error: error,
          timestamp: new Date().toISOString(),
        });
        fileErrorMessage = apiMessage || this.$t('upload.forbiddenError');
      }

      if (!fileErrorMessage && error.request && !error.response?.status) {
        console.error({
          message: 'The uploaded file was not received by the server.',
          error: error,
          timestamp: new Date().toISOString(),
        });
        fileErrorMessage = this.$t('upload.networkError');
      }

      if (!fileErrorMessage && error.response) {
        fileErrorMessage = apiMessage
          ? apiMessage
          : this.$t('upload.fileError', {
              fileName: result.file.file.name,
            });
      }

      return fileErrorMessage;
    },
    processFilesResults(results) {
      const resultMap = new Map(results.map((result) => [result.file, result]));
      let errorMessage = '';
      let hasAnyError = false;
      const updatedFiles = this.files.map((originalFile) => {
        const result = resultMap.get(originalFile);

        if (!result) {
          console.warn('Result missing. Original file: ', originalFile);
          return originalFile;
        }

        if (result.status === 'success') {
          this.$set(originalFile, 'file', result.data);
          this.$set(originalFile, 'fromApi', true);
          this.$delete(originalFile, 'loading');
          return originalFile;
        }

        if (result.status === 'error') {
          hasAnyError = true;
          const fileErrorMessage = this.processFileErrorMessage(result);
          this.$set(
            originalFile,
            'canRetry',
            result.error.response?.status !== 422
          );
          errorMessage = `${fileErrorMessage} ${result.file.file.name}`;
          originalFile.error = errorMessage;
          this.$delete(originalFile, 'loading');
          return originalFile;
        }

        return originalFile;
      });

      if (hasAnyError) {
        const alertMessage = this.$t('upload.error');
        alert.fireAlert(alertMessage, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
      }

      this.files = updatedFiles;
      return this.files;
    },
    hasFilesErrors() {
      const hasErrors = this.files.some((file) => file.error);
      if (hasErrors) {
        console.error({
          message: 'Files with errors',
          error: this.files.filter((file) => file.error),
          timestamp: new Date().toISOString(),
        });
        return true;
      }
      return false;
    },
    async onSelectFiles(selectedFiles) {
      const concat = [].concat(this.files, selectedFiles);
      if (this.maxFilesPerEnvelope < concat.length) {
        ToastAlert.fireAlert(
          this.$t('modal.envelope.maxFilesPerEnvelopeError', {
            maxFilesPerEnvelope: this.maxFilesPerEnvelope,
          }),
          {
            classes: 'alert-warning',
            styles:
              'background-color: #FFFCE2; border-color: #EBE5A7; color: #635B00;',
            tag: 'httpAlert',
            icon: 'circle-exclamation',
          }
        );
        return;
      }
      if (this.isNew) {
        this.files = concat;
        return;
      }
      selectedFiles = selectedFiles.map((f) => ({
        ...f,
        ...{ loading: true },
      }));
      const oldFiles = [...this.files];
      this.files = [].concat(this.files, selectedFiles);
      this.$loading(true);
      try {
        const res = await this.addFiles(this.envelopeId, selectedFiles);
        this.processFilesResults(res);
        if (this.hasFilesErrors()) {
          return;
        }
      } catch (error) {
        this.files = oldFiles;
      }
      this.$loading(false);
    },
    dragover(event) {
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      this.$refs.fileUpload.$refs.modal.open();
      this.$refs.fileUpload.loadFile(event, true);
      this.dragging = false;
    },
    async retryFile(file) {
      const envelopeId = this.envelopeId || this.internalEnvelopeId;

      if (!envelopeId) {
        return;
      }
      console.info('Retry upload file: ', file);
      this.$set(file, 'loading', true);
      this.$set(file, 'error', null);
      try {
        const results = await this.addFiles(envelopeId, [file]);
        this.processFilesResults(results);
      } catch (error) {
        console.error({
          message: 'Error retrying file upload',
          file: file.file.name,
          error: error,
          timestamp: new Date().toISOString(),
        });
        this.$set(file, 'loading', false);
      }
    },
    async removeFile(file) {
      if (file.fromApi === true) {
        await EnvelopesService.removeDocument(
          this.envelopeId || this.internalEnvelopeId,
          file.id || file.file.id
        );
      }
      this.removeFileFromList(file);
    },
    removeFileFromList(file) {
      this.files = this.files.filter((f) => f !== file);
    },
    async saveAndClose() {
      if (this.isNew) {
        if (!(await this.createEnvelope())) {
          return;
        }
      }

      if (this.hasPDFAEnabled && !this.isNew) {
        const updated = await this.updateMetadata(this.envelopeId);
        if (updated === false) {
          return;
        }
      }

      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.push({ name: 'business.documents.draft' });
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="stylus" scoped>
.w-center
  margin: auto
  max-width: 960px
.card--file-loader
  text-align: center
  border: 2px dashed #3ECB90
  color: #013D52
  padding: 1rem
  box-shadow: 0 3px 5px #00000029
  &:hover
    background-color: #eaeaea
  .card-title
    font-size: 1.5rem
  .btn
    padding-left: 1rem
    padding-right: 1rem
  .dragenterClass
    cursor: grabbing
    cursor: -webkit-grabbing
    background:rgba(0,0,0,0.1)
    .notclickable
      pointer-events: none
      h3
        pointer-events: none
      p
        pointer-events: none
.files-list .file-item
  position: relative
  border: 1px solid #CCCCCC
  border-radius: 3px
  max-width: 250px
  margin: auto
  margin-left: 0
  .preview
    width: 100%
    height: 110px
    border-top-left-radius: 3px
    border-top-right-radius: 3px
    background-size: cover
    background-position: initial
    background-repeat: no-repeat
    text-align: center
    .icon
      color: #949494
      font-size: 2.5em
      margin: auto
  .file-name
    border-radius: 0 0 3px 3px
    font-size: 0.9rem
    margin-top: -6px
    padding: 10px 7px
    padding-right: 23px
    overflow: hidden
    text-overflow: ellipsis
    background: #fff
    white-space: nowrap
  .file-error
    border-radius: 0 0 3px 3px
    font-size: 0.9rem
    margin-top: -3px
    padding: 10px 7px
    padding-right: 50px
    white-space: normal
    word-break break-word
    overflow: hidden
    text-overflow: clip
    color: #721C24
  .actions
    position: absolute
    bottom: 8px
    right: 4px
    button
      color: #949494
  .danger
    color: #721C24
    background-color: #f8d7da
    border-color: #F5C6CB

  &:has(.file-error)
    .actions button
      color: #721C24
      &:hover
        color: #949494

.btn-link-menu
  font-size: 1rem
  text-decoration: underline
  color: #0080a3 !important
  padding: 0

  .plan-details-link
    color: inherit
    text-decoration: none

    &:visited, &:hover, &:active
      color: inherit
      text-decoration: none
</style>
